export const clientModelMixin = {
  data() {
    return {
      clientModelObj: {
        org_id: null,
        trainer_id: null,
        user: null,
        email: null,
        password: null,
        device_token: null,
        os_type: null,
        joined_on: null,
        profile: {
          firstName: null,
          lastName: null,
          phone: null,
          image: null,
          gender: null,
          dob: null,
          status: null,
          subscribed: false,
          start_date: null,
          end_date: null,
          subscribed_plan: null,
          last_seen: null,
          successfulSignup: false,
          mediaAssets: {
            avatarImage: {
              url: null,
            },
          },
          healthConditions: [],
          injuries: [],
        },
        progress: {
          initial: {
            weight: {
              isImperial: null,
              value: null,
            },
            height: {
              isImperial: null,
              value: null,
            },
            chest: {
              isImperial: null,
              value: null,
            },
            hip: {
              isImperial: null,
              value: null,
            },
            waist: {
              isImperial: null,
              value: null,
            },
            bmi: {
              isImperial: null,
              value: null,
            },
          },
          latestCheckIn: {
            weight: {
              isImperial: null,
              value: null,
            },
            height: {
              isImperial: null,
              value: null,
            },
            chest: {
              isImperial: null,
              value: null,
            },
            hip: {
              isImperial: null,
              value: null,
            },
            waist: {
              isImperial: null,
              value: null,
            },
            bmi: {
              isImperial: null,
              value: null,
            },
          },
          goals: {
            weight: {
              isImperial: null,
              value: null,
            },
            height: {
              isImperial: null,
              value: null,
              remainder: null,
            },
            chest: {
              isImperial: null,
              value: null,
            },
            hip: {
              isImperial: null,
              value: null,
            },
            waist: {
              isImperial: null,
              value: null,
            },
            bmi: {
              isImperial: null,
              value: null,
            },
            customGoals: [null],
          },
          mediaAssets: {
            front: {
              url: null,
            },
            back: {
              url: null,
            },
            side: {
              url: null,
            },
          },
        },
        metrics: {
          dateOfLastWorkout: null,
          workoutsCompleted: null,
          exercisesCompleted: null,
          totalWorkoutDurationSeconds: null,
        },
        latestPostWorkoutReview: {
          remainingEnergyPercent: null,
          progressTowardsGoal: null,
          anyOtherFeedback: null,
        },
        trainerNotes: [
          {
            trainer_id: null,
            date: null,
            subject: null,
            body: null,
          },
        ],
        program: {
          program_id: null,
          creation_date: null,
        },
        invitation: {
          source_name: null,
          source_id: null,
          link: null,
          sent_at: null,
          reSent_at: null,
          price_plan: null,
        },
      },
    };
  },
  methods: {
    getClientModel() {
      return this.clientModelObj;
    },
  },
};
